const __WEBPACK_NAMESPACE_OBJECT__ = require("@neuralegion/cypress-har-generator");